import React from "react";
import classnames from "classnames";
import { Card } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";

import IconSpinner from "components/IconSpinner";

import "./ActionCard.scss";

interface PlaidLinkUpdateCardProps {
  // propTypes declares onClick as func, but it is rendered as a node child
  // ({onClick}); typed as ReactNode to match actual usage.
  onClick?: React.ReactNode;
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  actionText?: string;
  completedAction?: boolean;
  loading?: boolean;
  disabled?: boolean;
  color?: string;
}

const PlaidLinkUpdateCard = ({
  onClick,
  icon,
  color,
  title,
  description,
  completedAction,
  loading,
  disabled,
}: PlaidLinkUpdateCardProps) => (
  <Card>
    <Card.Body>
      <div>
        <div className="action-card-details">
          {icon && (
            <div className="action-icon-container">
              <div
                className={`action-icon-circle ${
                  color === "red" ? "red-color" : "primary-color"
                }`}
              >
                <div className="action-icon">{icon}</div>
              </div>
            </div>
          )}
          <h5 className="action-card-title">{title}</h5>
          <p className="action-card-description">{description}</p>
        </div>
        {!completedAction && !loading && (
          <div className={classnames("action-card-action", { disabled })}>
            {onClick}
          </div>
        )}
        {completedAction && (
          <div className="action-card-action completed-action">
            <div className="success-icon">
              <FaCheckCircle size={24} color="#4BB543" />
            </div>
          </div>
        )}
        {loading && (
          <div className="action-card-action action-card-loading">
            <IconSpinner />
          </div>
        )}
      </div>
    </Card.Body>
  </Card>
);

export default PlaidLinkUpdateCard;
